/* eslint-disable no-nested-ternary */
import { darken, lighten } from 'polished'
import { path } from 'ramda'

export const defaultStyle = (color, size, buttonStyle, disabled) => {
  const buttonTheme = {
    green: '#50AD34',
    yellow: '#ffb907',
    blue: '#2d8abd',
    red: '#e40e31'
  }

  const buttonSize = {
    extraSmall: {
      width: '100%',
      height: '24px'
    },
    small: {
      width: '100%',
      height: '36px'
    },
    normal: {
      width: '100%',
      height: '48px'
    },
    big: {
      width: '100%',
      height: '56px'
    },
    icon: {
      width: '48px',
      height: '48px'
    }
  }

  const colorToUse = buttonTheme[color] ? buttonTheme[color] : color || '#1abc9c'
  const isIcon = buttonStyle === 'icon'

  const fontSize = {
    small: 12,
    normal: 14
  }

  const bgColorStyle = {
    outline: {
      initial: 'transparent',
      hover: 'transparent'
    },
    onlyText: {
      initial: 'transparent',
      hover: lighten(0.55, colorToUse)
    },
    onlyTextSecondary: {
      initial: 'transparent',
      hover: '#f4f5f7'
    },
    icon: {
      initial: 'transparent',
      hover: '#f4f5f7'
    },
    default: {
      initial: colorToUse,
      hover: darken(0.08, colorToUse)
    }
  }

  const borderStyle = {
    outline: {
      initial: `1px solid #c8ccd4`,
      hover: `1px solid #1abc9c`
    },
    onlyText: {
      initial: 'none',
      hover: 'none'
    },
    onlyTextSecondary: {
      initial: 'none',
      hover: 'none'
    },
    default: {
      initial: 'none',
      hover: 'none'
    }
  }

  const colorStyle = {
    outline: colorToUse,
    onlyText: colorToUse,
    onlyTextSecondary: '#000',
    icon: '#000',
    default: '#fff'
  }

  const returnColoring = style => `
    border: ${path([style, 'initial'], borderStyle) || borderStyle.default.initial};
    color: ${colorStyle[style] || colorStyle.default};
    background-color: ${path([style, 'initial'], bgColorStyle) || bgColorStyle.default.initial};

    &:focus,
    &:hover {
      border: ${path([style, 'hover'], borderStyle) || borderStyle.default.hover};
      background-color: ${path([style, 'hover'], bgColorStyle) || bgColorStyle.default.hover};
      color: ${colorStyle[style] || colorStyle.default};
    };
  `

  return `
    ${returnColoring(buttonStyle)}
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: ${isIcon ? buttonSize.icon.width : buttonSize[size].width};
    margin-bottom: 0;
    font-weight: 600;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    white-space: nowrap;
    border-radius: 5px;
    position: relative;
    overflow: visible;
    line-height: 18px;
    font-size: ${fontSize[size] ? fontSize[size] : 14};
    height: ${buttonSize[size].height || buttonSize.normal.height};
    transition: background .3s ease, border .2s ease;
    opacity: ${disabled ? 0.65 : 1};
    &:hover,
    &:focus {
      outline: none;
    }
    &:disabled {
      cursor: not-allowed;
      pointer-events: none;
      color: #6e798e;
      background-color: ${buttonStyle === 'outline' ? 'transparent' : '#c8ccd4'};
    }
    &:disabled + i {
      color: #6e798e;
    }
  `
}